export default {
  welcome: '开启与gotin的旅程吧！',
  welcomeNjcb: '欢迎进入“你好世界”，\n开启元宇宙探索之旅！',
  firstName: '名',
  lastName: '姓',
  createAccount: '注册新用户',
  email: '请输入邮箱（推荐使用公司邮箱）',
  enterPassword: '设置密码',
  rePassword: '再次输入密码',
  tips: '点击“注册”或“领英登录”即代表您已阅读并同意使用条款。',
  registerUser: '注册用户',
  success: '注册成功',
  exists: '该账号已注册，请直接登录',
  notExists: '账号未注册',
  bindedPhone: '当前手机号已被绑定，请直接登录',
  bindedEmail: '当前邮箱已被绑定，请直接登录',
  login: '登录',
  register: '注册',
  next: '下一步',
  //
  backLogin: '返回登录',
  createAccount1: '注册用户',
  email1: '邮箱',
  recommendEmail: '推荐使用公司邮箱',
  setPass: '设置密码',
  setANewPassword: '设置密码',
  showPasswordRules: '密码至少为8位字符，并同时包含字母和数字',
  confirmPass: '再次输入密码',
  or: '或者',
  linkedinLogin: '领英登录',
  inputEmail: '请输入邮箱',
  inputPhone: '请输入手机号码',
  enterYourEmail: '输入您的邮箱',
  enterYourPhone: '手机号码',
  needCanUseEmail: '必须是可用邮箱',
  needCanUsePhone: '必须是可用的手机号码',
  setPassPop: '请输入密码',
  eightMinPassword: '密码最短为 8 位',
  passwordRules: '请按照要求设置密码',
  confirmPassPop: '请确认密码',
  reInputPassword: '请再次输入密码',
  noMatchPassword: '密码不一致，请重新输入',
  // acceptTermsPop: '请确认用户协议',
  acceptTermsPop: '请勾选使用条款及隐私政策',
  emailConsent: '宣传推广电子信息同意书',
  emailConsentText:
    '为确保您及时了解移动行业的最新动态，我们希望向您发送有关活动，产品，服务和倡议的信息以及行业新闻。请通过左方勾选此框来订阅; 您可以随时取消订阅电邮更新。',
  subscribe: '订阅有了平台的新闻资讯及通知',
  readPreText: '继续则表明我已阅读并同意有了平台的',
  readPreTextPorsche718: '我已阅读并同意平台的',
  readPreTextAIA: '本人阅读并同意',
  readPreTextZlzp: '我已阅读并同意平台的',
  and: '及',
  andPorsche718: '及',
  andPreTextZlzp: '及',
  termsName: '使用条款',
  privacyPolicyName: '隐私政策',
  labelRegisteredPhone: '请输入您的手机号码',
  labelCode: '请输入验证码',
  verificationCode: '请输入验证码',
  offLine: '网络不稳定，请稍后再试',
  owndesc: '注：未注册的手机号验证后将自动为您创建账户',
  porscheOwndesc718: '未注册手机号将自动为您创建账号',
  gsmaAgreeReadPreText:
    '本人同意 GSMA 集团（具体包括 GSMA Ltd LLC、GSMA 4YFN Event Management, SL、GSM 协会、GSMA Advisory Services Ltd、GSMA Services LLC 和集伺盟会展服务（上海）有限公司）向我发送有关 GSMA 活动以及 GSMA 产品与服务的信息。这些信息包括 GSMA 的各类活动、其设备/网络服务，以及移动行业的新闻与洞察。请通过勾选此框进行订阅；订阅后，您可以随时根据需要定制接收的内容，或根据意愿取消订阅。有关 MWC 巴塞罗那如何收集和处理您的数据的更多信息，请参阅',
  gsmaAgreeReadPreText2:
    '，作为注册MWC线上直播的前提条件。（注：若不同意，将无法完成注册。）',
  gsmaAgreeReadPreText3: '《MWC 巴塞罗那与4YFN 参会者隐私声明》。',
}
